import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=63ae6f07&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ae6f07')) {
      api.createRecord('63ae6f07', component.options)
    } else {
      api.reload('63ae6f07', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=63ae6f07&", function () {
      api.rerender('63ae6f07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GCDyrT1lNgin/JS/childrenage.vue"
export default component.exports